import { render, staticRenderFns } from "./creatGroup.vue?vue&type=template&id=fe859b20&scoped=true&"
import script from "./creatGroup.vue?vue&type=script&lang=ts&"
export * from "./creatGroup.vue?vue&type=script&lang=ts&"
import style0 from "./creatGroup.vue?vue&type=style&index=0&id=fe859b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe859b20",
  null
  
)

export default component.exports